export default __webpack_public_path__ + "static/media/safety_color.92ad1255.svg";